import createIcon from '../../createIcon';

/**
 * @component @name TabUnselected
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSA5SDNWN0gxVjlaTTEgMTNIM1YxMUgxVjEzWk0xIDVIM1YzQzEuOSAzIDEgMy45IDEgNVpNOSAyMUgxMVYxOUg5VjIxWk0xIDE3SDNWMTVIMVYxN1pNMyAyMVYxOUgxQzEgMjAuMSAxLjkgMjEgMyAyMVpNMjEgM0gxM1Y5SDIzVjVDMjMgMy45IDIyLjEgMyAyMSAzWk0yMSAxN0gyM1YxNUgyMVYxN1pNOSA1SDExVjNIOVY1Wk01IDIxSDdWMTlINVYyMVpNNSA1SDdWM0g1VjVaTTIxIDIxQzIyLjEgMjEgMjMgMjAuMSAyMyAxOUgyMVYyMVpNMjEgMTNIMjNWMTFIMjFWMTNaTTEzIDIxSDE1VjE5SDEzVjIxWk0xNyAyMUgxOVYxOUgxN1YyMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TabUnselected = createIcon('TabUnselected', [
  [
    'path',
    {
      d: 'M1 9H3V7H1V9ZM1 13H3V11H1V13ZM1 5H3V3C1.9 3 1 3.9 1 5ZM9 21H11V19H9V21ZM1 17H3V15H1V17ZM3 21V19H1C1 20.1 1.9 21 3 21ZM21 3H13V9H23V5C23 3.9 22.1 3 21 3ZM21 17H23V15H21V17ZM9 5H11V3H9V5ZM5 21H7V19H5V21ZM5 5H7V3H5V5ZM21 21C22.1 21 23 20.1 23 19H21V21ZM21 13H23V11H21V13ZM13 21H15V19H13V21ZM17 21H19V19H17V21Z',
      key: 'l5k8wq',
    },
  ],
]);

export default TabUnselected;
